// Всё время показывается в Europe/Moscow независимо от настроек устройства.
export const DISPLAY_TZ = 'Europe/Moscow';

const fmtTime = new Intl.DateTimeFormat('ru-RU', {
  timeZone: DISPLAY_TZ, hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});
const fmtDate = new Intl.DateTimeFormat('ru-RU', {
  timeZone: DISPLAY_TZ, day: 'numeric', month: 'long', year: 'numeric',
});
const fmtDayShort = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'UTC', day: 'numeric', month: 'long',
});
const fmtWeekday = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', weekday: 'short' });
const fmtParts = new Intl.DateTimeFormat('en-CA', {
  timeZone: DISPLAY_TZ, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});

function toDate(v: string | Date): Date { return typeof v === 'string' ? new Date(v) : v; }

/** HH:mm в Москве, 24 часа, с ведущим нулём — для ленты. */
export function feedTime(v: string | Date): string {
  return fmtTime.format(toDate(v));
}

/** «11 ноября 2026, 12:32» — для отдельной карточки. */
export function cardDateTime(v: string | Date): string {
  const d = toDate(v);
  return `${fmtDate.format(d).replace(/\s*г\.$/, '')}, ${fmtTime.format(d)}`;
}

/** «2026-11-11 12:32:46» — для админки. */
export function adminDateTime(v: string | Date): string {
  const p = Object.fromEntries(fmtParts.formatToParts(toDate(v)).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}:${p.second}`;
}

/** День трансляции хранится как календарная дата (YYYY-MM-DD). */
export function dayLabel(day: string): string {
  return fmtDayShort.format(new Date(`${day}T00:00:00Z`));
}
export function weekdayLabel(day: string): string {
  return fmtWeekday.format(new Date(`${day}T00:00:00Z`));
}

/** Преобразует «YYYY-MM-DDTHH:mm» (московское локальное) в ISO UTC. Москва — UTC+3 без переходов. */
export function moscowLocalToIso(local: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(local);
  if (!m) throw new Error('bad local datetime');
  const [, y, mo, d, h, mi, s] = m;
  return new Date(Date.UTC(+y, +mo - 1, +d, +h - 3, +mi, s ? +s : 0)).toISOString();
}
export function isoToMoscowLocal(iso: string): string {
  return adminDateTime(iso).replace(' ', 'T').slice(0, 16);
}
